import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  min-height: 100vh;
  min-width: 100vw;
  background: hsl(0, 0%, 60%, 0.7);
  display: ${({ isModalOpen }) => !isModalOpen && 'none'};
  text-decoration: none;
`;

const Availabiity = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 0.5rem;
  border-right: 1px solid lightgray;
  border-left: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
`;

const Flex = styled.div`
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  padding: 1rem;
  border-right: 1px solid lightgray;
  border-left: 1px solid lightgray;
  border-bottom: 1px solid lightgray;

  span {
    display: flex;
    align-items: center;
  }
  p {
    display: flex;
    align-items: center;
    margin-left: 1rem;
  }
`;

const ModalMenu = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  background: white;
  border-radius: 10px;
`;

export { Flex, Availabiity, ModalMenu };

export default Container;
